import React from 'react';
import {Redirect, Switch} from "react-router-dom";
import {BasePage} from "app/types/PageTypes";

const EmployeesPage = (props: BasePage) => {
  return (
      <Switch>
        {props.children}
        <Redirect to='/employees/employees-list'/>
      </Switch>
  );
};

export default EmployeesPage;